import { defineMessages } from 'react-intl';

export const msgs = defineMessages({
  ctaMovie: {
    id: 'pib_communicate_cta_1',
  },
  ctaCinema: {
    id: 'pib_communicate_cta_2',
  },
  label: {
    id: `pib_mission_label`,
  },
});

export const en_us = defineMessages({
  titleCinema: {
    id: 'pib_communicate_cta_header_en',
  },
  titleMovie: {
    id: 'pib_communicate_cta_1_header_en',
  },
});

export const es = defineMessages({
  titleCinema: {
    id: 'pib_communicate_cta_header_es',
  },
  titleMovie: {
    id: 'pib_communicate_cta_1_header_es',
  },
});
